<ion-content class="ion-padding bg-white dark:bg-slate-900">
    <div class="container">
        <!-- Rich Hero -->
        <section class="hero-bleed relative overflow-hidden my-0">
            <div
                class="absolute -left-40 -top-24 opacity-30 blur-3xl transform rotate-12 w-96 h-96 bg-gradient-to-r from-primary-400 to-purple-400 rounded-full">
            </div>
            <div
                class="absolute -right-32 -bottom-20 opacity-20 blur-2xl w-80 h-80 bg-gradient-to-r from-amber-300 to-pink-300 rounded-full">
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-8 items-center relative z-10">
                <!-- Left: personal intro -->
                <div class="space-y-6 flex flex-col">
                    <div class="glass">
                        <div class="flex items-center gap-4">
                            <img src="assets/alessandro.png" alt="{{ name }}"
                                class="w-20 h-20 rounded-full object-cover shadow-md" />
                            <div>
                                <h1 class="text-3xl md:text-4xl font-extrabold leading-tight text-white">{{ name }}</h1>
                                <p class="text-sm text-slate-200">Front End Development Manager</p>
                            </div>
                        </div>

                        <p class="text-lg text-slate-200 mt-4 text-justify">{{ 'home.bio' | t }}</p>

                        <!-- Prominent bot reply bubble (main hero) -->
                        <div *ngIf="lastBotMessage && !isAwaitingResponse" class="mt-6">
                            <div class="rounded-xl bg-black/60 dark:bg-black/60 text-white p-6 shadow-lg">
                                <p class="text-lg leading-relaxed" style="overflow: auto; height: 80px;">{{ lastBotMessage }}</p>
                            </div>
                        </div>
                        <!-- Thinking spinner (visible while awaiting response) -->
                        <div *ngIf="isAwaitingResponse" class="mt-6">
                            <div class="rounded-xl bg-black/60 dark:bg-black/60 text-white p-6 shadow-lg">
                                <div class="flex gap-2 items-center">
                                    <span class="w-3 h-3 bg-white/80 rounded-full animate-bounce" style="animation-delay:0ms"></span>
                                    <span class="w-3 h-3 bg-white/80 rounded-full animate-bounce" style="animation-delay:160ms"></span>
                                    <span class="w-3 h-3 bg-white/80 rounded-full animate-bounce" style="animation-delay:320ms"></span>
                                </div>
                                <div class="mt-2 text-xs text-slate-200/90">Stato avatar: {{ avatarMotionState.toUpperCase() }}</div>
                            </div>
                        </div>
                        <div class="flex flex-wrap gap-3 items-center mt-6">
                            <div class="w-full md">
                                <div *ngIf="isStartupLoading" class="rounded-xl bg-black/45 text-white p-5 shadow-lg border border-white/15">
                                    <div class="flex items-center gap-3">
                                        <span class="w-3 h-3 bg-white/80 rounded-full animate-bounce" style="animation-delay:0ms"></span>
                                        <span class="w-3 h-3 bg-white/80 rounded-full animate-bounce" style="animation-delay:140ms"></span>
                                        <span class="w-3 h-3 bg-white/80 rounded-full animate-bounce" style="animation-delay:280ms"></span>
                                        <span class="text-sm md:text-base">{{ startupStatusText }}</span>
                                    </div>
                                    <div class="mt-3 text-xs text-slate-200/90">
                                        <div>Modello in-browser: <strong>{{ inBrowserLoading ? 'caricamento...' : 'pronto' }}</strong></div>
                                        <div>Avatar 3D: <strong>{{ avatarLoading ? 'caricamento...' : 'pronto' }}</strong></div>
                                    </div>
                                    <div *ngIf="inBrowserError" class="text-sm text-red-300 mt-2">Errore modello: {{ inBrowserError }}</div>
                                    <div *ngIf="avatarError" class="text-sm text-red-300 mt-1">Errore avatar: {{ avatarError }}</div>
                                </div>

                                <div *ngIf="isAssistantReady">
                                <form class="prompt-shell" (submit)="$event.preventDefault(); onSend(mainInput.value); mainInput.value='';">
                                    <div class="prompt-head">{{ 'home.writeHere' | t }}</div>
                                    <div class="prompt-row">
                                        <input
                                            #mainInput
                                            type="text"
                                            placeholder=""
                                            [disabled]="isAwaitingResponse"
                                            class="prompt-input"
                                            aria-label="Messaggio" />

                                        <button
                                            type="button"
                                            (click)="toggleListening('main')"
                                            [disabled]="isAwaitingResponse"
                                            [class.is-active]="isListening && currentListeningTarget==='main'"
                                            [class.opacity-60]="!supportsSpeechRecognition"
                                            class="icon-btn"
                                            aria-label="Attiva microfono">
                                            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                                <path d="M12 3a3 3 0 0 0-3 3v5a3 3 0 1 0 6 0V6a3 3 0 0 0-3-3z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M5 11a7 7 0 0 0 14 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                                                <path d="M12 18v3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                                            </svg>
                                        </button>

                                        <button
                                            type="submit"
                                            [disabled]="isAwaitingResponse"
                                            class="send-btn"
                                            aria-label="Invia messaggio">
                                            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                                <path d="M4 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                                                <path d="M13 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </button>
                                    </div>
                                    <div class="prompt-underline"></div>
                                </form>

                                <div class="suggestions-wrap" aria-label="Suggerimenti">
                                    <button
                                        *ngFor="let suggestion of quickSuggestions"
                                        type="button"
                                        class="suggestion-chip"
                                        [disabled]="isAwaitingResponse"
                                        (click)="onSuggestionClick(suggestion, mainInput)">
                                        {{ suggestion }}
                                    </button>
                                </div>

                                <div class="inline-block align-middle mt-3">
                                    <div class="w-20 h-2 bg-white/10 rounded overflow-hidden">
                                        <div class="h-2 bg-green-400" [style.width.%]="micLevel * 100"></div>
                                    </div>
                                    <div *ngIf="currentListeningTarget==='main' && listeningHint" class="text-xs text-yellow-300">{{ listeningHint }}</div>
                                </div>

                                <div class="mt-2">
                                    <span class="text-sm text-slate-200">
                                        Modello in-browser: pronto
                                    </span>
                                    <span class="text-sm text-slate-200 ml-3">
                                        Avatar: {{ avatarMotionState.toUpperCase() }}
                                    </span>
                                    <div *ngIf="inBrowserError" class="text-sm text-red-300 mt-1">Errore: {{ inBrowserError }}</div>
                                    <div *ngIf="avatarError" class="text-sm text-red-300 mt-1">Errore avatar: {{ avatarError }}</div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right: 3D character (kept for small screens) -->
                <div class="flex justify-center md:justify-end">
                    <div class="relative w-72 md:w-80 lg:w-96 flex flex-col items-center model-wrap">
                        <div class="w-64 h-64 model-bg rounded-lg shadow-lg mobile-model"></div>
                        <div class="mt-3 w-full" *ngIf="isAssistantReady">
                            <form class="flex gap-2 items-center"
                                (submit)="$event.preventDefault(); onSend(messageInput.value); messageInput.value='';">
                                <button type="button" (click)="toggleListening('message')"
                                    [disabled]="isAwaitingResponse"
                                    [class.opacity-60]="!supportsSpeechRecognition"
                                    [class.bg-red-600]="isListening && currentListeningTarget==='message'"
                                    class="px-3 py-2 rounded-md mr-2 bg-primary-700 text-white">🎤</button>
                                <div class="inline-block align-middle ml-2">
                                    <div class="w-20 h-2 bg-white/10 rounded overflow-hidden">
                                        <div class="h-2 bg-green-400" [style.width.%]="micLevel * 100"></div>
                                    </div>
                                    <div *ngIf="currentListeningTarget==='message' && listeningHint"
                                        class="text-xs text-yellow-300">{{ listeningHint }}</div>
                                </div>
                                <input #messageInput type="text"
                                    placeholder="{{ 'home.writeHere' | t }}"
                                    [disabled]="isAwaitingResponse"
                                    class="flex-1 px-3 py-2 rounded-md bg-white/80 dark:bg-white/10 text-slate-800 dark:text-white placeholder:text-slate-500 dark:placeholder:text-slate-400" />
                                <ion-button type="submit" color="primary" fill="outline" size="large" [disabled]="isAwaitingResponse">
                                    {{ isAwaitingResponse ? 'Attendi...' : 'Invia' }}
                                </ion-button>
                            </form>
                            <div class="mt-2 space-y-2">
                                <div *ngFor="let m of messages">
                                    <div *ngIf="m.from==='user'"
                                        class="inline-block px-3 py-2 rounded-lg bg-white/80 text-slate-800 text-sm">Tu:
                                        {{ m.text }}</div>
                                    <div *ngIf="m.from==='bot' && m.text"
                                        class="inline-block px-3 py-2 rounded-lg bg-white/90 text-slate-900 text-sm font-medium">
                                        Assistente: {{ m.text }}</div>
                                </div>
                                <div *ngIf="isAwaitingResponse" class="flex gap-1.5 items-center px-3 py-2">
                                    <span class="w-2 h-2 bg-white/70 rounded-full animate-bounce" style="animation-delay:0ms"></span>
                                    <span class="w-2 h-2 bg-white/70 rounded-full animate-bounce" style="animation-delay:160ms"></span>
                                    <span class="w-2 h-2 bg-white/70 rounded-full animate-bounce" style="animation-delay:320ms"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Fixed positioned model: bottom-left on large screens -->
            <div class="model-fixed">
                <div #modelContainer class="model-bg fixed-canvas rounded-lg shadow-lg"></div>
                <div class="model-controls" *ngIf="isAssistantReady">
                    <form class="flex gap-2 items-center"
                        (submit)="$event.preventDefault(); onSend(sideInput.value); sideInput.value='';">
                        <button type="button" (click)="toggleListening('side')"
                            [disabled]="isAwaitingResponse"
                            [class.opacity-60]="!supportsSpeechRecognition"
                            [class.bg-red-600]="isListening && currentListeningTarget==='side'"
                            class="px-3 py-1 rounded-md mr-2 bg-primary-700 text-white">🎤</button>
                        <div class="inline-block align-middle ml-2">
                            <div class="w-20 h-2 bg-white/10 rounded overflow-hidden">
                                <div class="h-2 bg-green-400" [style.width.%]="micLevel * 100"></div>
                            </div>
                            <div *ngIf="currentListeningTarget==='side' && listeningHint"
                                class="text-xs text-yellow-300">{{ listeningHint }}</div>
                        </div>
                        <input #sideInput type="text" placeholder="{{ 'home.writeHere' | t }}"
                            [disabled]="isAwaitingResponse"
                            class="px-3 py-2 rounded-md bg-white/80 dark:bg-white/10 text-slate-800 dark:text-white placeholder:text-slate-500 dark:placeholder:text-slate-400" />
                        <ion-button type="submit" color="primary" fill="outline" size="small" [disabled]="isAwaitingResponse">
                            {{ isAwaitingResponse ? 'Attendi...' : 'Invia' }}
                        </ion-button>
                    </form>
                </div>
            </div>
        </section>
    </div>
</ion-content>